// extracted by mini-css-extract-plugin
module.exports = {"widgetItem":"WidgetItem_widgetItem__3-rep","title":"WidgetItem_title__6yATx","lastItem":"WidgetItem_lastItem__3FVXX"};